<div class="info-content">
    <span *ngFor="let message of messages">{{message}}</span>
</div>
